export default function SignatureFromTextPreview({
    text,
    fontFamily,
    fontSize,
    color,
    backgroundMode,
    emptyTitle,
    emptyHint,
}) {
    const trimmed = text.trim();

    if (!trimmed) {
        return (
            <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center px-6 text-center">
                <div className="text-[15px] font-semibold text-[#3D3833] dark:text-zinc-200">{emptyTitle}</div>
                {emptyHint ? (
                    <div className="mt-0.5 text-[12.5px] text-[#A8A099] dark:text-zinc-500">{emptyHint}</div>
                ) : null}
            </div>
        );
    }

    const checkerClass = backgroundMode === 'transparent'
        ? 'bg-[length:16px_16px] bg-[position:0_0,8px_8px] bg-[image:linear-gradient(45deg,#ECE8E4_25%,transparent_25%,transparent_75%,#ECE8E4_75%,#ECE8E4),linear-gradient(45deg,#ECE8E4_25%,transparent_25%,transparent_75%,#ECE8E4_75%,#ECE8E4)] dark:bg-[image:linear-gradient(45deg,#3f3f46_25%,transparent_25%,transparent_75%,#3f3f46_75%,#3f3f46),linear-gradient(45deg,#3f3f46_25%,transparent_25%,transparent_75%,#3f3f46_75%,#3f3f46)]'
        : 'bg-white dark:bg-zinc-900';

    return (
        <div className={`flex h-full min-h-0 flex-1 items-center justify-center overflow-hidden rounded-xl p-8 ${checkerClass}`}>
            <p
                className="max-w-full break-words text-center leading-none"
                style={{
                    fontFamily: `"${fontFamily}", cursive`,
                    fontSize: `${fontSize}px`,
                    color,
                    fontStyle: fontFamily === 'Tiro Bangla' ? 'italic' : 'normal',
                }}
            >
                {trimmed}
            </p>
        </div>
    );
}
